import React from "react";

/**
 * Compact top header — approximately 1/3 shorter than the previous version
 * per approved product direction. Hero content now begins sooner.
 *
 * Account controls intentionally live in the shared authenticated shell.
 * This component owns page title, subtitle, accents, and page-specific actions.
 */
export default function TopHeader({ title, subtitle, accent, actions, hideTitleOnMobile = false }) {
  return (
    <header className="flex items-center justify-between mb-4 pt-1">
      <div className="min-w-0 flex items-center gap-2">
        {/* MXR-001 · Global MobileTopStrip provides the mobile-nav
            hamburger site-wide, so per-workspace TopHeader instances
            no longer render their own. */}
        <div className={`min-w-0 ${hideTitleOnMobile ? "hidden sm:block" : ""}`}>
          <h1
            className="font-display text-[22px] sm:text-[26px] lg:text-[30px] tracking-tight leading-tight text-[#0F172A] font-bold truncate"
            data-testid="cc-page-title"
          >
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1.5 font-body text-[12px] sm:text-[13px] text-[#475569] flex items-center gap-2 leading-tight truncate">
              {subtitle}
              {accent && (
                <span className="inline-flex items-center justify-center">
                  {accent}
                </span>
              )}
            </p>
          )}
        </div>
      </div>

      {actions && <div className="flex shrink-0 items-center gap-2 sm:gap-4">{actions}</div>}
    </header>
  );
}
